export enum OrganizationType {
  NYCBS = "HhwIHO4npKhrxyylkC33",
  MBM = "3GKbZtgpPru1vJGCkxwR",
  MBP = "3GKbZtgpPru1vJGCkxwR",
  CHC = "4BlQ4SsqAVTDgFKApKZr",
  ASTERA = "tPvNbDprUnrXIJlDXyxs",
  DEMO_FACILITY = "57zhkss5CaF9dz90wcpv",
  NYCBS_DRUG_CONFIG = "hwKXreFwPrMpA8Pad7Mr",
  NYCBS_PHARMA = "hwKXreFwPrMpA8Pad7Mr",
  UCBC = "W14MolgUu7OYvX4CFQJn",
  NYCBS_HYD = "Y15ePfa5kC35QiChxXil",
}
